export const SET_LANG = "SET_LANG";
export const SET_LANGS_LIST = "SET_LANGS_LIST";
export const SET_LOCALE = "SET_LOCALE";

const initialState = {
  languageId: 1,
  languageName: "eng",
  languageList: [],
  locale: "en-gb",
};

const langReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LANG:
      return {
        ...state,
        languageId: action.payload.id,
        languageName: action.payload.code,
      };
    case SET_LANGS_LIST:
      return {
        ...state,
        languageList: action.payload,
      };
    case SET_LOCALE:
      return {
        ...state,
        locale: action.payload ? action.payload : "en-gb",
      };

    default:
      return state;
  }
};

export default langReducer;
